<button tabindex="-1" id="hidden" #hiddenElement class="position-absolute top-0 end-0 opacity-0"></button>
<div class="searchBarWrapper">
  <div class="ng-select-wrapper" #parentContainer>
     <ng-select
      #ngSelectRef
      class="searchDropdown w-100 m-0 p-0"
      [items]="data"
      bindLabel="name"
      bindValue="id"
      [searchable]="true"
      [clearable]="false"
      [disabled]="disabled"
      [(ngModel)]="selectValue"
      [ngClass]="{ 'is-valid': isValid, 'ng-select-focused': isFocused, 'notAllowed': disabled }"
      (change)="onSelectionChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (open)="onOpen(parentContainer)"
      (close)="onClose()"
      notFoundText="No records available"
      [disabledKey]="'disabled'"
    >
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">

        <div
          class="text-truncate font-14 text-start"
          [ngClass]="{'disabled-option' : item.disabled}"
          [class.text-gray]="item.disabled"
          [class.notAllowed]="item.disabled"
        >
          {{ item.name }}
        </div>
      </ng-template>
    </ng-select>
 
    <label class="label-transition" [class.active]="selectValue || isFocused">
      {{ selectLabel }}
      <i *ngIf="required" class="fst-normal ps-0 p-0 text-danger">*</i>
    </label>
 
    <span
      *ngIf="!disabled"
      [ngClass]="{ invisible: !selectValue }"
      (click)="clearSelection()"
      id="testing-decision"
      class="refresh-icon hand"
    >
      <app-svg class="svgIcon" iconType="UndoSVG"></app-svg>
    </span>
 
    <div *ngIf="isSvgVisible" class="imgValid" [ngClass]="{ 'is-valid': isValid }">
      <img src="../../../../assets/SVGIcons/lock.svg" alt="" />
    </div>
  </div>
</div>